// extracted by mini-css-extract-plugin
export default {"paletteContainer":"styles_paletteContainer__cn6bi","paletteSection":"styles_paletteSection__6ixj+"};